import { Box, Typography, TypographyProps } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import React from "react";
import { UITooltip } from "./UITooltip";

interface HeadingWithTooltipProps {
  /** The heading text to display */
  title: string;
  /** The tooltip content to show on hover */
  tooltip: string;
  /** Typography variant for the heading */
  variant?: TypographyProps["variant"];
  /** Tooltip placement */
  placement?: "top" | "bottom" | "left" | "right";
}

/**
 * A reusable component that displays a heading with an optional help tooltip icon.
 * Used for section headings that need explanatory tooltips.
 */
export const HeadingWithTooltip: React.FC<HeadingWithTooltipProps> = ({
  title,
  tooltip,
  variant = "h5",
  placement = "top",
}) => {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography variant={variant}>{title}</Typography>
      <UITooltip
        title={tooltip}
        placement={placement}
        sx={{
          fontSize: "14px",
          lineHeight: 1.4,
        }}
      >
        <HelpOutlineIcon
          sx={{
            fontSize: 18,
            color: "text.secondary",
            cursor: "help",
            "&:hover": {
              color: "primary.main",
            },
          }}
        />
      </UITooltip>
    </Box>
  );
};
